import { wpData } from './wpDataType';
import { createSlice } from '@reduxjs/toolkit';

const root: any = window?.post_template;
const clean: any = window.clean_settings;
const settings: any = window.general_settings;

const initialState = {
  settings: {
    logo: settings?.logo,
    logoWhite: settings?.logo_white,
    brandName: settings?.brand_name,
    formattedString: window.formattedString,
    phone: settings?.phone_number,
    email: settings?.support_email,
    link: window?.cta_link,
    root: window.template_root,
    bundleAmount: window.post_template.product_page_v6_hero.product_page_v6_hero_bundlePrice,
    hideAdd: window.productData?.shopping_cart?.shopping_cart_hide_upsell_view_modals,
    disableCart: window.productData?.shopping_cart?.shopping_cart_disable_cart,
    emptyCart: window.productData?.shopping_cart?.shopping_cart_empty,
    disablePrices: window.post_template.product_page_v6_hero.product_page_v6_hero_showPrices,
    showPriceInCTA: window.post_template.product_page_v6_hero?.product_page_v6_hero_showCTAPrica,
    showEachLabel: window.post_template.product_page_v6_hero?.product_page_v6_hero_showEach,
    showQtyIncrementer: window.post_template.product_page_v6_hero?.product_page_v6_hero_showIncrementer,
    isHeroVisible: true,
  },
  cleanSettings: {
    cleanMode: clean,
  },
  theme: {
    button: root?.product_page_v6_components?.product_page_v6_button_theme,
    heading: root?.product_page_v6_components?.product_page_v6_headings_theme,
    headingColor: root?.product_page_v6_components?.product_page_v6_title_text_color,
    subheadingColor: root?.product_page_v6_components?.product_page_v6_subtitle_text_color,
    timer: root?.product_page_v6_components?.product_page_v6_shipping_time,
    customButton: {
      background: root?.product_page_v6_components?.product_page_v6_button_background,
      backgroudHover: root?.product_page_v6_components?.product_page_v6_button_background_hover,
      borderColor: root?.product_page_v6_components?.product_page_v6_button_background_border,
      textColor: root?.product_page_v6_components?.product_page_v6_button_text_color,
      borderColorSecondary: root?.product_page_v6_components?.product_page_v6_button_background_borderSecondary,
      hoverColorSecondary: root?.product_page_v6_components?.product_page_v6_button_hover_secondary,
      hoverTextColorSecondary: root?.product_page_v6_components?.product_page_v6_button_texthover_secondary,
    },
  },

  layout: {
    hero: {
      display: root.product_page_v6_hero?.product_page_v6_hero_show,
      layout: root.product_page_v6_hero?.product_page_v6_hero_layout || '',
    },
    featuredIn: {
      display: root.product_page_v6_slider?.product_page_v6_slider_display,
      layout: '',
    },
    videoTestimonials: {
      display: root?.product_page_v6_reviews?.product_page_v6_reviews_show,
      order: 5,
    },
    middleBar: {
      display: root?.product_page_v6_middleBar?.product_page_v6_middleBar_show,
    },
    videoTestimonialsImages: {
      display: root?.product_page_v6_reviews?.product_page_v6_reviewSlider_show,
    },
    baComparison: {
      display: root?.product_page_v6_baComparison?.product_page_v6_baComparison_show,
      order: root?.product_page_v6_baComparison?.product_page_v6_baComparison_order,
    },
    features: {
      display: root?.product_page_v6_featureslist?.product_page_v6_featuresList_show,
      layout: '',
    },
    setup: {
      display: root?.product_page_v6_setup?.product_page_v6_setup_show,
      layout: '',
    },
    competitorsComparison: {
      display: root?.product_page_v6_competitors?.product_page_v6_competitors_show,
      order: root?.product_page_v6_competitors?.product_page_v6_competitors_order,
    },
    products: {
      display: root?.product_page_v6_products?.product_page_v6_products_show,
      layout: '',
    },
    testimonialsSlider: {
      display: root?.product_page_v6_testimonials?.product_page_v6_testimonials_show,
      layout: '',
    },

    ribbon: {
      display: root?.product_page_v6_benefitsRibbon?.product_page_v6_benefitsRibbon_showSection,
      layout: '',
    },
    faq: {
      display: root?.product_page_v6_faq?.product_page_v6_faq_display,
      layout: '',
    },
    awards: {
      display: root?.product_page_v6_awardCard?.product_page_v6_award_show,
      layout: '',
    },
    expert: {
      display: root?.product_page_v6_expert?.product_page_v6_expert_show,
      layout: '',
    },
    reviews: {
      display: root?.product_page_v6_reviewsList?.product_page_v6_reviewsList_show,
      layout: root?.product_page_v6_reviewsList?.product_page_v6_reviewsList_layout || '',
    },
    floater: {
      display: root?.product_page_v6_floater?.product_page_v6_floater_show,
      layout: '',
    },
  },
  header: {
    headerNavigationLinks: root?.product_page_v6_navigation?.product_page_v6_navigation_links,
    headerNavRightButtonText: root?.product_page_v6_navigation?.tr_product_page_v6_navigation_cta,
    headerNavRightButtonLink: root?.product_page_v6_navigation?.product_page_v6_navigation_cta_link,
    styles: {
      background: root?.product_page_v6_navigation?.product_page_v6_navigation_background,
      textColor: root?.product_page_v6_navigation?.product_page_v6_navigation_linkColor,
      textHoverColor: root?.product_page_v6_navigation?.product_page_v6_navigation_linkHover,
      borderColor: root?.product_page_v6_navigation?.product_page_v6_navigation_borderColor,
    },
  },
  discountBar: {
    text: root.product_page_v6_discountBar?.tr_product_page_v6_discountBar_text,
    timer: root?.product_page_v6_discountBar?.product_page_v6_discountBar_time,
    styles: {
      background: root.product_page_v6_discountBar?.product_page_v6_discountBar_background,
      textColor: root.product_page_v6_discountBar?.product_page_v6_discountBar_color,
    },
  },
  middleBar: {
    list: root?.product_page_v6_middleBar?.product_page_v6_middleBar_list,
    styles: {
      background: root?.product_page_v6_middleBar?.product_page_v6_middleBar_background,
      textColor: root?.product_page_v6_middleBar?.product_page_v6_middleBar_primaryColor,
    },
  },
  hero: {
    title: root?.product_page_v6_hero?.tr_product_page_v6_hero_heading,
    subtitle: root?.product_page_v6_hero?.tr_product_page_v6_hero_subheading,
    hero_image: root?.product_page_v6_hero?.product_page_v6_hero_staticImage,
    show_socials: root?.product_page_v6_hero?.product_page_v6_hero_showSocials,
    show_stockLeft: root?.product_page_v6_hero?.product_page_v6_hero_showStockLeft,
    divider_text: root?.product_page_v6_hero?.tr_product_page_v6_hero_dividerText,
    bought_this: root?.product_page_v6_hero?.tr_product_page_v6_hero_bought_this,
    instaBubbles: root?.product_page_v6_hero?.product_page_v6_hero_bubbles,
    chart_label: root?.product_page_v6_hero?.tr_product_page_v6_hero_chartLabel,
    free_label: root?.product_page_v6_hero?.tr_product_page_v6_hero_freeLabel,
    left_label: root?.product_page_v6_hero?.tr_product_page_v6_hero_leftLabel,
    availability_label: root?.product_page_v6_hero?.tr_product_page_v6_hero_limitedAvailability,
    each_label: root?.product_page_v6_hero?.tr_product_page_v6_hero_eachLabel,
    star_rating: {
      rating: root?.product_page_v6_hero?.product_page_v6_hero_score,
      rating_text: root?.product_page_v6_hero?.tr_product_page_v6_hero_ratingText,
      ratings_count: '158',
      ratings_count_text: root?.product_page_v6_hero?.tr_product_page_v6_hero_reviewsLabel,
      ratings_count_text_mobile: root?.product_page_v6_hero?.tr_product_page_v6_hero_reviewsLabel_mobile,
    },
    testimonials: root?.product_page_v6_hero?.product_page_v6_hero_testimonials,
    gallery: root?.product_page_v6_hero?.product_page_v6_hero_imageGallery,
    useVideo: root?.product_page_v6_hero?.product_page_v6_hero_imageGallery.use_video,
    galleryImage: root?.product_page_v6_hero?.product_page_v6_hero_imageGallery.gallery_image,
    cloudflareVideoId: root?.product_page_v6_hero?.product_page_v6_hero_imageGallery.cloudflare_video_id,
    cloudflareVideoThumb: root?.product_page_v6_hero?.product_page_v6_hero_imageGallery.cloudflare_video_thumb,
    cloudflareVideoAutoplay: root?.product_page_v6_hero?.product_page_v6_hero_imageGallery.cloudflare_video_autoplay,
    cloudflareVideo: root?.product_page_v6_hero?.product_page_v6_hero_imageGallery.cloudflare_video_loop,

    faqList: root?.product_page_v6_hero?.product_page_v6_hero_faq,
    shopWithin: root?.product_page_v6_hero?.tr_product_page_v6_hero_orderWithin,
    shopWihinTwo: root?.product_page_v6_hero?.tr_product_page_v6_hero_orderWithin_two,
    checklist: root?.product_page_v6_hero?.product_page_v6_hero_checklist,
    benefits: root?.product_page_v6_hero?.product_page_v6_hero_features,
    ctaButtonText: root?.product_page_v6_hero?.tr_product_page_v6_hero_ctaLabel,
    styles: {
      background: root?.product_page_v6_hero?.product_page_v6_hero_backgroundColor,
      borderColor: root?.product_page_v6_hero?.product_page_v6_hero_borderColor,
      textColorPrimary: root?.product_page_v6_hero?.product_page_v6_hero_textPrimary,
      textColorSubtitle: root?.product_page_v6_hero?.product_page_v6_hero_text_color_subtitle,
      textColorSecondary: root?.product_page_v6_hero?.product_page_v6_hero_textSecondary,
      textColorItemsLeft: root?.product_page_v6_hero?.product_page_v6_hero_text_items_left,
      checkIconColor: root?.product_page_v6_hero?.product_page_v6_hero_checkmarkicon,
      accentColor: root?.product_page_v6_hero?.product_page_V6_hero_text_accent,
      bestSellerColor: root?.product_page_v6_hero?.product_page_v6_hero_background_best_seller,
      bestValueColor: root?.product_page_v6_hero?.product_page_v6_hero_background_best_value,
      featureTitleColor: root?.product_page_v6_hero?.product_page_v6_hero_featuresTitle_color,
      ratingsRowColor: root?.product_page_v6_hero?.product_page_v6_hero_ratingsRow_color,
      priceColor: root?.product_page_v6_hero?.product_page_v6_hero_priceColor,
      oldPriceColor: root?.product_page_v6_hero?.product_page_v6_hero_old_price_color,
      activeColor: root?.product_page_v6_hero?.product_page_v6_activecolor,
      radioColor: root?.product_page_v6_hero?.product_page_v6_radioColor,
      checkmarkColor: root?.product_page_v6_hero?.product_page_v6_checkmarkColor,
      testimonialsNameColor: root?.product_page_v6_hero?.product_page_v6_testimonials_username_color,
      shippingTextColor: root?.product_page_v6_hero?.product_page_v6_shipping_text_color,
      accordionTitleColor: root?.product_page_v6_hero?.product_page_v6_accordion_title_color,
      activeHeroThumbnailBorder: root?.product_page_v6_hero?.product_page_v6_gallery_image_border_color,
      dividerTextColor: root?.product_page_v6_hero?.product_page_v6_divider_text_color,
    },
  },
  logoSlider: {
    staticImage: root?.product_page_v6_slider?.product_page_v6_slides_image,
    repeater: root?.product_page_v6_slider?.product_page_v6_slider_slides,
    styles: {
      background: root?.product_page_v6_slider.product_page_v6_slider_background,
    },
  },
  features: {
    show: root?.product_page_v6_featureslist?.product_page_v6_featuresList_show,
    title: root?.product_page_v6_featureslist?.tr_product_page_v6_featureslist_heading,
    subtitle: root?.product_page_v6_featureslist?.tr_product_page_v6_featureslist_subheading,
    score: root?.product_page_v6_featureslist?.product_page_v6_featuresList_score,
    starsValue: root?.product_page_v6_featureslist?.product_page_v6_featuresList_stars,
    reviewsCount: root?.product_page_v6_featureslist?.product_page_v6_featuresList_reviews_count,
    reviewsLabel: root?.product_page_v6_featureslist?.tr_product_page_v6_featuresList_reviews_label,
    list: root?.product_page_v6_featureslist?.product_page_v6_featureslist_repeater,
    styles: {
      background: root?.product_page_v6_featureslist?.product_page_v6_featuresList_background,
      textColorPrimary: root?.product_page_v6_featureslist?.product_page_v6_featuresList_primaryColor,
      textColorSecondary: root?.product_page_v6_featureslist?.product_page_v6_featuresList_secondaryColor,
      checkboxColor: root?.product_page_v6_featureslist?.product_page_v6_featuresList_colorAccent,
    },
  },
  setup: {
    title: root?.product_page_v6_setup?.tr_product_page_v6_setup_title,
    subtitle: root?.product_page_v6_setup?.tr_product_page_v6_setup_subtitle,
    show: root?.product_page_v6_setup?.product_page_v6_setup_show,
    list: root?.product_page_v6_setup?.product_page_v6_setup_repeater,
    styles: {
      background: root?.product_page_v6_setup?.product_page_v6_setup_sectionBackground,
      textColorPrimary: root?.product_page_v6_setup?.product_page_v6_setup_textPrimary,
      textColorSecondary: root?.product_page_v6_setup?.product_page_v6_setup_textSecondary,
    },
  },
  FloatingCTA: {
    floaterImage: root?.product_page_v6_floater?.product_page_v6_floater_image,
    starsImage: root?.product_page_v6_floater?.product_page_v6_floater_stars,
    productScore: root?.product_page_v6_floater?.product_page_v6_floater_score,
    ctaLabel: root?.product_page_v6_floater?.tr_product_page_v6_floater_cta,
    timerLabel: root?.product_page_v6_floater?.tr_product_page_v6_floater_timer,
    floaterHeading: root?.product_page_v6_floater?.tr_product_page_v6_floater_heading,
    verbalScore: root?.product_page_v6_floater?.tr_product_page_v6_floater_scoreVerbal,
    styles: {
      background: root?.product_page_v6_floater?.product_page_v6_floater_gradient,
      textColorPrimary: root?.product_page_v6_floater?.product_page_v6_floater_textColorPrimaryy,
      textColorSecondary: root?.product_page_v6_floater?.product_page_v6_floater_textColorSecondary,
      buttonBackground: root?.product_page_v6_floater.product_page_v6_floater_ctaBackground,
      ctaTextColor: root?.product_page_v6_floater.product_page_v6_floater_textColor,
      buttonHoverBackground: root?.product_page_v6_floater?.product_page_v6_floater_hoverColor,
    },
  },
  competitorsComparison: {
    heading: root?.product_page_v6_competitors?.tr_product_page_v6_competitors_heading,
    tableHeading: root?.product_page_v6_competitors?.tr_product_page_v6_competitors_tableHeading,
    ctaLabel: root?.product_page_v6_competitors?.tr_product_page_v6_competitors_cta,
    moneyBackLabel: root?.product_page_v6_competitors?.tr_product_page_v6_competitors_moneyBack,
    otherProduct: root?.product_page_v6_competitors?.tr_product_page_v6_competitors_otherLabel,
    productImage: root?.product_page_v6_competitors?.product_page_v6_competitors_image,
    ourProductLogo: root?.product_page_v6_competitors?.product_page_v6_competitors_our_product_logo,
    competitorsImage: root?.product_page_v6_competitors?.product_page_v6_competitors_otherImage,
    repeater: root?.product_page_v6_competitors?.product_page_v6_competitors_table,
    styles: {
      background: root?.product_page_v6_competitors?.product_page_v6_competitors_background,
      evenTable: root?.product_page_v6_competitors?.product_page_v6_competitors_even,
      oddTable: root?.product_page_v6_competitors?.product_page_v6_competitors_odd,
      textColorPrimary: root?.product_page_v6_competitors?.product_page_v6_competitors_primaryColor,
      tetColorSecondary: root?.product_page_v6_competitors?.product_page_v6_competitors_secondaryColor,
      oddTableOur: root?.product_page_v6_competitors?.product_page_v6_competitors_oddOur,
      evenTableOur: root?.product_page_v6_competitors?.product_page_v6_competitors_evenOur,
    },
  },
  testimonialsSwiper: {
    title: root?.product_page_v6_testimonials?.tr_product_page_v6_testimonials_heading,
    subtitle: root?.product_page_v6_testimonials?.tr_product_page_v6_testimonials_subheading,
    ratedLabel: root?.product_page_v6_testimonials?.tr_product_page_v6_ratedLabel,
    verifiedLabel: root?.product_page_v6_testimonials?.tr_product_page_v6_testimonials_verifiedLabel,
    list: root?.product_page_v6_testimonials?.product_page_v6_testimonials_repeater,
    styles: {
      borderColor: root?.product_page_v6_testimonials?.product_page_v6_testimonials_border_color,
      cardBackground: root?.product_page_v6_testimonials?.product_page_v6_testimonials_cardBackgrounddd,
      background: root?.product_page_v6_testimonials?.product_page_v6_testimonials_background,
      textColorPrimary: root?.product_page_v6_testimonials?.product_page_v6_testimonials_primary_color,
      textColorSecondary: root?.product_page_v6_testimonials?.product_page_v6_testimonials_secondary_color,
      textColorAccent: root?.product_page_v6_testimonials?.product_page_v6_testimonials_accent_color,
    },
  },

  // Cart ACF from Product Pack (Bundle Pack)
  cart: {
    dividerLabel: window.post_template.product_page_v6_cart?.tr_product_page_v6_cart_divider_label || '',
    cartLabel: window.post_template.product_page_v6_cart?.tr_product_page_v6_cart_cart_label || '',
    savingsLabel: window.post_template.product_page_v6_cart?.tr_product_page_v6_cart_savings_label || '',
    subtotalLabel: window.post_template.product_page_v6_cart?.tr_product_page_v6_cart_subtotal_label || '',
    timerLabel: window.post_template.product_page_v6_cart?.tr_product_page_v6_cart_timer_label || '',
    bestSellerLabel: window.post_template.product_page_v6_cart?.tr_product_page_v6_cart_bestSeller_label || '',
    bestValueLabel: window.post_template.product_page_v6_cart?.tr_product_page_v6_cart_bestValue_label || '',
    ctaLabel: window.post_template.product_page_v6_cart?.tr_product_page_v6_cart_cta_label || '',
    upgradeLabel: window.post_template.product_page_v6_cart?.tr_product_page_v6_cart_upgrade_label || '',
    viewLabel: window.post_template.product_page_v6_cart?.tr_product_page_v6_cart_view_label || '',
    addLabel: window.post_template.product_page_v6_cart?.tr_product_page_v6_cart_add_label || '',
    freeShippingLabel: window.post_template.product_page_v6_cart?.tr_product_page_v6_cart_freeShipping,
    freeShippingUnlockLabel: window.post_template.product_page_v6_cart?.tr_product_page_v6_cart_shipping,
    styles: {
      colorPrimary: window.post_template.shopping_cart?.shopping_cart_text_color_primary || '',
      colorSecondary: window.post_template.shopping_cart?.shopping_cart_text_color_secondary || '',
      badgeColor: window.post_template.shopping_cart?.shopping_cart_best_seller_badge_color || '',
      shippingBarColor: window.post_template.shopping_cart?.shopping_cart_free_shipping_bar_color,
      accentColor: window.post_template.shopping_cart?.shopping_cart_accent_color,
    },
  },
  baComparison: {
    title: root?.product_page_v6_baComparison?.tr_product_page_v6_baComparison_heading,
    list: root?.product_page_v6_baComparison?.product_page_v6_baComparison_repeater,
    verified: root?.product_page_v6_baComparison?.tr_product_page_v6_baComparison_verified,
    styles: {
      background: root?.product_page_v6_baComparison?.product_page_v6_baComparison_background,
      textColorPrimary: root?.product_page_v6_baComparison?.product_page_v6_baComparison_primaryColor,
      textColorSecondary: root?.product_page_v6_baComparison?.product_page_v6_baComparison_secondaryColor,
    },
  },
  videoTestimonials: {
    title: root?.product_page_v6_reviews?.tr_product_page_v6_reviews_heading,
    rating: 4.7,
    ratingText: root?.product_page_v6_reviews?.tr_product_page_v6_reviews_trusted,
    verifiedText: 'Verified',
    verifyIcon: 'http://127.0.0.1:5173/images/homepage/testimonialsSection/testimonialCard/verify.svg',
    testimonials: root?.product_page_v6_reviews?.product_page_v6_reviews_video_repeater,
    styles: {
      background: root?.product_page_v6_reviews?.product_page_v6_reviews_background,
    },
  },
  videoTestimonialsImages: {
    repeater: root?.product_page_v6_reviews?.product_page_v6_reviews_images,
  },
  productsSection: {
    title: root?.product_page_v6_products?.tr_product_page_v6_products_heading,
    reviewsText: 'Verified Reviews',
    products: root?.product_page_v6_products?.product_page_v6_products_sectionRepeater,
    styles: {
      background: root?.product_page_v6_products?.product_page_v6_products_background,
      backgroundAccent: root?.product_page_v6_products?.product_page_v6_products_backgroundAccent,
      backgroundBadge: root?.product_page_v6_products?.product_page_v6_products_backgroundDiscount,
      textColorPrimary: root?.product_page_v6_products?.product_page_v6_products_textPrimary,
      textColorSpan: root?.product_page_v6_products?.product_page_v6_products_textColorSpan,
      textColorSecondary: root?.product_page_v6_products?.product_page_v6_products_textSecondary,
      accentColor: root?.product_page_v6_products?.product_page_v6_products_textAccent,
      badgeColor: root?.product_page_v6_products?.product_page_v6_products_background,
      borderColor: root?.product_page_v6_products?.product_page_v6_products_cardDefaultBorder,
      borderColorHover: root?.product_page_v6_products?.product_page_v6_products_card_borderColorOnHover,
    },
  },

  slidingTextBar: {
    repeater: root?.product_page_v6_benefitsRibbon?.product_page_v6_benefitsRibbon_repeater,
    styles: {
      background: root?.product_page_v6_benefitsRibbon?.product_page_v6_benefitsRibbon_background,
      textColor: root?.product_page_v6_benefitsRibbon?.product_page_v6_benefitsRibbon_textColor,
    },
  },
  FAQ: {
    sectionTitle: root?.product_page_v6_faq?.tr_product_page_v6_faq_title,
    items: root?.product_page_v6_faq?.product_page_v6_faq_list_repeater,
    styles: {
      background: root?.product_page_v6_faq?.product_page_v6_faq_background,
      titleColor: root?.product_page_v6_faq?.product_page_v6_faq_titleColor,
    },
  },

  awards: {
    rating: '',
    title: root?.product_page_v6_awardCard?.tr_product_page_v6_award_heading,
    subtitle: root?.product_page_v6_awardCard?.tr_product_page_v6_award_subheading,
    image: root?.product_page_v6_awardCard?.product_page_v6_award_productImage,
    awardImage: root?.product_page_v6_awardCard?.product_page_v6_award_badge,
  },
  expertBlock: {
    showSection: root?.product_page_v6_expert.product_page_v6_expert_show,
    title: root?.product_page_v6_expert?.tr_product_page_v6_expert_meetExpertLabel,
    subtitle: root?.product_page_v6_expert?.product_page_v6_expert_occupation,
    text: root?.product_page_v6_expert?.tr_product_page_v6_expert_recommendation,
    name: root?.product_page_v6_expert?.product_page_v6_expert_name,
    ourStory: root?.product_page_v6_expert?.tr_product_page_v6_expert_ourStory,
    avatarUrl: root?.product_page_v6_expert?.product_page_v6_expert_image,
    withLove: 'With Love,',
    signatureImgUrl: root?.product_page_v6_expert?.product_page_v6_expert_signature,
    styles: {
      colorPrimary: root?.product_page_v6_expert?.product_page_v6_expert_primaryColor,
      background: root?.product_page_v6_expert?.product_page_v6_expert_background,
      colorAccent: root?.product_page_v6_expert?.product_page_v6_expert_accentColor,
      borderColor: root?.product_page_v6_expert?.product_page_v6_border_color,
      expertTitleColor: root?.product_page_v6_expert?.product_page_v6_expert_title_color,
      expertSpecialityColor: root?.product_page_v6_expert?.product_page_v6_expert_speciality_color,
    },
  },

  customerReviewsBlock: {
    title: root?.product_page_v6_reviewsList?.tr_product_page_v6_reviewsList_title,
    subtitle: root?.product_page_v6_reviewsList?.tr_product_page_v6_reviewsList_subtitle,
    reviews: root?.product_page_v6_reviewsList?.product_page_v6_reviewsList_repeater,
    showLessLabel: root?.product_page_v6_reviewsList?.tr_product_page_v6_reviewslist_loadLess,
    showMoreLabel: root?.product_page_v6_reviewsList?.tr_product_page_v6_reviewslist_readmore,
    verifiedLabel: root?.product_page_v6_reviewsList?.tr_product_page_v6_reviewsList_verified,
    helpfulLabel: root?.product_page_v6_reviewsList?.tr_product_page_v6_reviewsList_helpfulLabel,
    loadSlides: root?.product_page_v6_reviewsList?.product_page_v6_reviewsList_index,
    styles: {
      background: root?.product_page_v6_reviewsList?.product_page_v6_reviewsList_background,
      buttonColor: root?.product_page_v6_reviewsList?.product_page_v6_reviewsList_buttonColor,
      bubbleBackground: root?.product_page_v6_reviewsList?.product_page_v6_reviewsList_initialBubbleColor,
    },
  },
  statistics: {
    reviewsLabel: root?.product_page_v6_reviews_score.tr_product_page_v6_reviews_score_reviewsLabel,
    writeReviewLabel: root?.product_page_v6_reviews_score.tr_product_page_v6_reviews_score_writeReviewLabel,
    numberOfReviews: root?.product_page_v6_reviews_score.product_page_v6_reviews_score_number,
    reviewsAverage: root?.product_page_v6_reviews_score.product_page_v6_reviews_score_int,
    percentOfReviewers: root?.product_page_v6_reviews_score.tr_product_page_v6_reviews_score_percent,
    repeater: root?.product_page_v6_reviews_score.product_page_v6_reviews_score_qualities,
    styles: {
      barActive: root?.product_page_v6_reviews_score.product_page_v6_reviews_score_colorActive,
      barPassive: root?.product_page_v6_reviews_score.product_page_v6_reviews_score_colorPassive,
      textColorPrimary: root?.product_page_v6_reviews_score.product_page_v6_reviews_score_colorPassive,
      textColorSecondary: root?.product_page_v6_reviews_score.product_page_v6_reviews_score_textSecondary,
      totalScoreColor: root?.product_page_v6_reviews_score.product_page_v6_reviews_score_total_score_color,
      numbersColor: root?.product_page_v6_reviews_score.product_page_v6_reviews_score_numbers_color,
      specificationsColor: root?.product_page_v6_reviews_score.product_page_v6_reviews_score_specifications_color,
    },
  },
  reviewModal: {
    formHeading: root?.product_page_v6_reviewForm.tr_product_page_v6_reviewForm_heading,
    ratingSelectLabel: root?.product_page_v6_reviewForm.tr_product_page_v6_reviewForm_selectLabel,
    nameLabel: root?.product_page_v6_reviewForm.tr_product_page_v6_reviewForm_nameLabel,
    reviewTitleLabel: root?.product_page_v6_reviewForm.tr_product_page_v6_reviewForm_titleLabel,
    reviewLabel: root?.product_page_v6_reviewForm.tr_product_page_v6_reviewForm_reviewLabel,
    pictureLabel: root?.product_page_v6_reviewForm.tr_product_page_v6_reviewForm_pictureLabel,
    selectImagesLabel: root?.product_page_v6_reviewForm.tr_product_page_v6_reviewForm_selectImagesLabel,
    maxImageLabel: root?.product_page_v6_reviewForm.tr_product_page_v6_reviewForm_maxImage,
    radioSelectLabel: root?.product_page_v6_reviewForm.tr_product_page_v6_reviewForm_radioLabel,
    yesLabel: root?.product_page_v6_reviewForm.tr_product_page_v6_reviewForm_yesLabel,
    noLabel: root?.product_page_v6_reviewForm.tr_product_page_v6_reviewForm_noLabel,
    submitLabel: root?.product_page_v6_reviewForm.tr_product_page_v6_reviewForm_submitLabel,
    requiredError: root?.product_page_v6_reviewForm.tr_product_page_v6_reviewForm_requiredError,
    errorLabel: root?.product_page_v6_reviewForm.tr_product_page_v6_reviewForm_error,
    thankYouLabel: root?.product_page_v6_reviewForm.tr_product_page_v6_reviewForm_thankyou,
    namePlaceholder: root?.product_page_v6_reviewForm.tr_product_page_v6_reviewForm_namePlaceholder,
    titlePlaceholder: root?.product_page_v6_reviewForm.tr_product_page_v6_reviewForm_titlePlaceholder,
    reviewPlaceholder: root?.product_page_v6_reviewForm.tr_product_page_v6_reviewForm_reviewPlaceholder,
  },
  footer: {
    verifiedReviews: root?.product_page_v6_footer?.tr_verifiedReviews,
    newsletter: {
      title: root?.product_page_v6_footer?.tr_newsLetter_title,
      formInputPlaceholder: root?.product_page_v6_footer?.tr_input_placeholder,
      formSubmitText: root?.product_page_v6_footer?.tr_submit_label,
      textAfterSubscribeForm: root?.product_page_v6_footer?.tr_submit_afterLabel,
      rating: 4.7,
    },
    benefits: root?.product_page_v6_footer?.product_page_v6_footer_benefits,
    text: root?.product_page_v6_footer?.tr_footer_product_description,
    copyText: root?.product_page_v6_footer?.tr_footer_copyrights_text,
    customerCareLabel: root?.product_page_v6_footer?.tr_footer_customer_care_label,
    emailSupportLabel: root?.product_page_v6_footer?.tr_footer_email_support_label,
    liveChatLabel: root?.product_page_v6_footer?.tr_footer_chat_support_label,
    links: root?.product_page_v6_footer?.footer_link_columns,
    styles: {
      background: root?.product_page_v6_footer?.footer_section_background_color,
      primaryColor: root?.product_page_v6_footer?.footer_text_color,
      linkHoverColor: root?.product_page_v6_footer?.footer_link_text_color_hover,
      borderColor: root?.product_page_v6_footer?.footer_borders_color,
      dividerColor: root?.product_page_v6_footer?.footer_divider_color,
    },
    footerLogo: root?.product_page_v6_footer?.footer_logo,
  },
};

const wpdataSlice = createSlice({
  name: 'wpdata',
  initialState,
  reducers: {},
});

export default wpdataSlice.reducer;
